// TEMPORARY web33 experiment. Teardown: delete this folder and remove its
// App.tsx, chart, analytics, debug, style, and version call sites.

import { locHtml } from "../../static/locHtml";

const pathRevealSplashElement = {
  name: "path-reveal-splash",
  type: "html",
  html: locHtml((t) => `
    <div class="web33-reveal">
      <div class="web33-reveal__chart" aria-hidden="true">
        <svg viewBox="0 0 300 160" role="img" aria-label="${t("splash.openingArc.pathReveal.chartLabel")}">
          <path class="web33-reveal__guide" d="M22 132 L278 28" />
          <path class="web33-reveal__guide" d="M22 132 C76 62 112 42 164 38 C214 34 244 33 278 32" />
          <path class="web33-reveal__guide" d="M22 132 C58 110 72 70 105 86 C139 102 151 48 184 65 C217 82 233 35 278 30" />
          <path class="web33-reveal__path" pathLength="1" d="M22 132 C48 118 65 82 92 88 C119 94 127 108 151 91 C178 71 180 48 208 54 C237 60 247 27 274 25" />
        </svg>
        <span class="web33-reveal__flag">🏁</span>
      </div>
      <h1>${t("splash.openingArc.pathReveal.title")}</h1>
      <div class="web33-reveal__copy">
        <p>${t("splash.openingArc.pathReveal.p1")}</p>
        <p>${t("splash.openingArc.pathReveal.p2")}</p>
        <p>${t("splash.openingArc.pathReveal.p3")}</p>
      </div>
    </div>
  `),
};

export { pathRevealSplashElement };
